import { Typography, Box } from "@jewlr/storybook/core"
import React from "react"
import { Link } from "react-router-dom"

import { Section, SectionTitle, SectionList, Text } from "@jewlr/storybook/info"
import { IS_NA, IS_UK, jewlr_t } from "helpers/application"
// import { freeGiftPromoEnabled } from "helpers/holiday"
import { to_currency } from "helpers/number"

const TermsConditions = () => {
  return (
    <Box mb={7}>
      <Section>
        <Box contain>
          <SectionTitle>PRIVACY POLICY</SectionTitle>
          <Text>
            Jewlr has improved our Terms and Conditions and Privacy Notice to
            make it easier for you to understand what data we collect and what
            it&apos;s used for. Refer to the{" "}
            <Link data-lc="terms-conditions" to="/info/privacy_notice">
              Privacy Notice
            </Link>{" "}
            for more information on the General Data Protection policy.
          </Text>
          <Text>
            Welcome to the www.jewlr.com website. These Terms and Conditions
            apply to all Jewlr websites including www.jewlr.com, www.jewlr.ca,
            www.jewlr.com.au, www.jewlr.co.uk, www.jewlr.eu, www.jewlr.de,
            www.jewlr.es, www.jewlr.fr and www.jewlr.nl. Jewlr.com and Jewlr UK
            Limited provides services to you subject to the notices, terms, and
            conditions set forth in this agreement (the &quot;Agreement&quot;).
            In addition, when you use any of our services (e.g., Customer
            Service), you will be subject to the rules, guidelines, policies,
            terms, and conditions applicable to such service, and they are
            incorporated into this Agreement by this reference. We reserve the
            right to change this Site and these terms and conditions at any time
            and the change will be effective immediately.
          </Text>
          <Text>
            Accessing, browsing or otherwise using the site indicates your
            agreement to all the terms and conditions in this agreement, so
            please read this agreement carefully before proceeding.
          </Text>
        </Box>
      </Section>
      <Section hasBg>
        <Box contain>
          <SectionTitle>SITE USE</SectionTitle>
          <Text>
            You represent and warrant that you are at least 18 years old or
            visiting the Site under the supervision of a parent or guardian.
          </Text>
          <Text>
            Subject to the Terms and Conditions of this Agreement, Jewlr,
            Jewlr.com and Jewlr UK Limited (JEWLR) hereby grant you a limited,
            revocable, non-transferable and non-exclusive license to access and
            use the Site by displaying it on your internet browser, your phone,
            or any electronic device only for the purpose of sharing or shopping
            for personal items sold on the Site and not for any commercial use
            or use on behalf of any third party, except as explicitly permitted
            by us in advance. Any breach of this Agreement shall result in the
            immediate revocation of the license granted without notice to you.
          </Text>
          <Text>
            Except as permitted in the paragraph above, you may not reproduce,
            distribute, display, sell, lease, transmit, create derivative works
            from, translate, modify, reverse-engineer, disassemble, decompile or
            otherwise exploit this Site or any portion of it unless expressly
            permitted by us in writing. You may not make any commercial use of
            any of the information provided on the Site or make any use of the
            Site for the benefit of another {jewlr_t("terms.business")} unless
            explicitly permitted by us in advance. We reserve the right to
            refuse service, terminate accounts, and/or cancel orders at our
            discretion, including, without limitation, if we believe that
            customer conduct violates applicable law or is harmful to our
            interests. You shall not upload to, distribute, or otherwise publish
            through this Site any Content, information, or other material that
            (a) violates or infringes the copyrights, patents, trademarks,
            service marks, trade secrets, or other proprietary rights of any
            person; (b) is libelous, threatening, defamatory, obscene, indecent,
            pornographic, or could give rise to any civil or criminal liability
            under U.S. or international law; or (c) includes any bugs, viruses,
            worms, trap doors, Trojan horses or other harmful code or
            properties.
          </Text>
          <Text>
            We may assign you a password and account identification to enable
            you to access and use certain portions of this Site. Each time you
            use a password or identification, you will be deemed to be
            authorized to access and use the Site in a manner consistent with
            the terms and conditions of this Agreement. YOU WILL BE SOLELY
            RESPONSIBLE FOR ALL ACCESS TO AND USE OF THIS SITE BY ANYONE USING
            THE PASSWORD AND IDENTIFICATION ORIGINALLY ASSIGNED TO YOU WHETHER
            OR NOT SUCH ACCESS TO AND USE OF THIS SITE IS ACTUALLY AUTHORIZED BY
            YOU, INCLUDING WITHOUT LIMITATION, ALL COMMUNICATIONS AND
            TRANSMISSIONS AND ALL OBLIGATIONS (INCLUDING WITHOUT LIMITATION
            FINANCIAL OBLIGATIONS) INCURRED THROUGH SUCH ACCESS OR USE. You are
            solely responsible for protecting the security and confidentiality
            of the password and identification assigned to you. You shall
            immediately notify us of any unauthorized use of your password or
            identification or any other breach or threatened breach of this
            Site&apos;s security.
          </Text>
        </Box>
      </Section>
      <Section>
        <Box contain>
          <SectionTitle mb={4}>
            PRODUCT AVAILABILITY, PRICING AND TRADEMARK
          </SectionTitle>
          <Text subtitle>Estimated Delivery</Text>
          <Text mb={4}>
            Sometimes with the volume of orders we receive, we are unable to
            fulfill the order in the estimated time. If this happens, we will
            attempt to notify you of the delay. While we make every attempt to
            avoid delays we do not guarantee delivery dates.
          </Text>
          <Text subtitle>Pricing</Text>
          <Text>
            The price of our products is based on the latest market values for
            precious metals and gems. We are constantly trying to pass our
            savings on to you with the various sales we offer throughout the
            year but we are unable to offer post-order price matching or post
            sales prices because our prices are based on the best prices we are
            able to get for you at the time. The price you paid when you placed
            your order was the lowest price we were able to offer at the time.
            In the same manner, we cannot extend a sale once it has ended. We do
            not negotiate prices on our products and all our prices are final.
            Our prices are subject to change without notice. Items in your
            shopping {jewlr_t("cart")} and Wish list will always reflect the
            most recent price displayed on the item&apos;s product detail page.
            This price may differ from the price shown for the item when you
            first placed it in your {jewlr_t("cart")}. Placing an item in your{" "}
            {jewlr_t("cart")} or Wish list doesn&apos;t reserve the price shown
            at that time.
          </Text>
          <Text mb={4}>
            JEWLR coupon and/or promo codes are subject to expire without
            notice. JEWLR will not accept expired coupons and/or promo codes
            even if they are linked from third party sites.
          </Text>
          <Text subtitle>Registered Trademark</Text>
          <Text>
            Jewlr items are stamped with our trademark &apos;TSD&apos;. This
            trademark can be used to identify our products and distinguish them
            from competitors. In addition, TSD is used in relation to the
            operation of our business of retail and wholesale stores and
            services featuring {jewlr_t("terms.jewelry")}, watches and giftware,
            repair services for {jewlr_t("terms.jewelry")}, silver and watch
            repairs, as well as engraving services, casting services, and 3D
            printing services of {jewlr_t("terms.jewelry")}, giftware, and
            watches.
          </Text>
        </Box>
      </Section>
      <Section hasBg>
        <Box contain>
          <SectionTitle>PROMOTIONS AND COUPONS</SectionTitle>
          <Text>
            Coupons and/or Promo codes are applied to the full order in the{" "}
            {jewlr_t("cart")} and will be applied to:
          </Text>
          <SectionList>
            <li>The original regular price of the items, or</li>
            <li>The on-sale price of the items, or</li>
            <li>
              The original price of the item less the multi-level discount
            </li>
          </SectionList>
          <Text>
            Intermediate markdowns may be removed to apply the multi-level
            discount to the full order.
          </Text>
          <Text>
            Coupons and/or Promo codes will not be applied to bundled items,
            free gifts (if applicable), or combined with any other offer.
            Coupons and/or Promo codes cannot be applied to:
          </Text>
          <SectionList mb={4}>
            <li>Luxury Bridal Collection custom center stones</li>
          </SectionList>
          {/* <Text subtitle>Spend More, Save More Offer</Text>
          <Text mb={4}>
            Valid for a limited time on total purchases of {to_currency(200)} or
            more, before taxes and after discounts or points redemptions are
            applied. Not valid on previous purchases. Excludes E-gift cards.
          </Text> */}
          {sl.config.sale_key.includes("2024_flash_sale") && (
            <>
              <Text subtitle>Flash Sale Offer</Text>
              <Text mb={4}>
                Offer cannot be combined with any other promo code or offer;
                Excludes bundles and Luxury Bridal Collection custom center
                stones; Other exclusions may apply; Not valid on previous
                purchases; Expires Nov. 18, 2024, at 11:59 PM EST.
              </Text>
            </>
          )}
          <Text subtitle>Typographic Error</Text>
          <Text mb={4}>
            Data, including prices, might be inaccurately displayed on our Site
            due to system or typographical errors while we make every attempt to
            avoid these errors. We reserve the right to correct any and all
            errors when they do occur, and we do not honor inaccurate or
            erroneous prices. If a product&apos;s listed price is lower than its
            actual price, we will either contact you for instructions before{" "}
            {jewlr_t("terms.shipping")} the product or cancel the order and
            notify you of such cancellation. If your credit card or payment
            method has already been charged for the purchase and your order is
            canceled, we shall immediately issue a credit to the account in the
            amount of the charge.
          </Text>
          <Text subtitle>Free Gifts</Text>
          <Text>
            At select times, we offer the option to choose a free gift with
            purchase. Free gifts are limited in quantity and subject to
            availability. JEWLR reserves the right to substitute a comparable
            free gift, without notice, if the selected free gift is not
            available.
          </Text>
          <Text subtitle>FLASH20</Text>
          <Text>
            Offer valid for a limited time only. Use code FLASH20 at checkout to
            receive 20% off your order of {to_currency(150)} or more (before
            taxes and {jewlr_t("terms.shipping")}). Offer cannot be combined
            with other promotions, discounts, or codes. Not valid on gift cards
            or previous purchases. Code does not apply to/will not be applied to
            bundled items, free gifts (if applicable), or combined with any
            other offer. Coupons and/or Promo codes cannot be applied to luxury
            Bridal Collection custom center stones.
          </Text>
          <Text subtitle>LAB10</Text>
          <Text>
            This promo code is valid for a discount on eligible products when a
            lab diamond is selected. The offer excludes JLUX rings and satellite
            chains. The discount applies only to the main product price,
            excluding additional components or services. It cannot be combined
            with other offers, applied to previous purchases, or used on gift
            cards. The code must be applied at checkout and is valid from April
            21st, 2025 to May 5th, 2025.
          </Text>
        </Box>
      </Section>
      <Section>
        <Box contain>
          <SectionTitle>RETURNS</SectionTitle>
          <Text>
            JEWLR offers a 99-day return policy. You may return an item for a
            refund (minus Deductions) within 99 days of the original{" "}
            {jewlr_t("terms.shipping")} date if the following conditions are
            met.
          </Text>
          <SectionList>
            <li>
              The item must be returned in a new and unworn condition. New and
              unworn condition means that there are no scratches, marks, or
              blemishes on the items. Items modified or re-sized are not
              considered new.
            </li>
            <li>
              The item must be postmarked within 99 days of the original
              shipment date.
            </li>
            <li>
              Items that have been resized, updated and/or repaired do not
              qualify for a refund.
            </li>
            <li>
              You are responsible for the return {jewlr_t("terms.shipping")}{" "}
              cost and the goods are your responsibility until they reach our
              warehouse.
            </li>
            <li>
              Luxury Bridal Collection items must be shipped to Jewlr using
              Jewlr’s {jewlr_t("terms.shipping")} provider.
            </li>
            <li>
              Promotional gifts must also be returned with your returned item.
            </li>
            <li>
              Your Luxury Bridal Collection diamond report must be returned with
              your One and Only Signature Collection item. $150 will be deducted
              from the Refund for missing or damaged reports
            </li>
            <li>
              Returns without a JEWLR Return Merchandise Authorization will be
              refused upon receipt.
            </li>
            <li>
              Pendants purchased as a donation to any charitable organization
              are not eligible for a refund - including, but not limited to, My
              Everyday Hero pendants.
            </li>
            <li>
              Non-{jewlr_t("terms.jewelry")} and final sale items such as{" "}
              {jewlr_t("terms.Jewelry")} Cleaner and {jewlr_t("terms.Jewelry")}{" "}
              Care Cloths are not eligible for a refund.
            </li>
            <li>
              Returns with missing paperwork or product will not be processed.
            </li>
          </SectionList>
          <Text>
            NOTE: Some special orders are non-returnable. We will inform you if
            an item cannot be returned before going ahead with your order.
          </Text>
        </Box>
      </Section>
      <Section hasBg>
        <Box contain>
          <SectionTitle>COMPARISON SHOPPING</SectionTitle>
          <Text>
            Every JEWLR item is made to order. JEWLR reserves the right to
            charge a 25% recycling fee in the rare case where a customer takes
            advantage of the return policy by ordering numerous{" "}
            {jewlr_t("terms.personalized")} items for the purposes of comparison
            or sizing. If we feel this is the case, we will contact you before
            manufacturing or {jewlr_t("terms.shipping")} the items.
          </Text>
        </Box>
      </Section>
      <Section>
        <Box contain>
          <SectionTitle>REFUND</SectionTitle>
          <Text mb={4}>
            Upon acceptance of your return, a credit will be issued to the
            original form of payment less any applicable deductions.
          </Text>
          <Text subtitle>Deductions</Text>
          <SectionList mb={4}>
            <li>
              JEWLR may provide a prepaid return- label for you to return the
              item. The value of this return label will be deducted from the
              refund. JEWLR will deduct the value of the bonus gift if the gift
              is not returned.
            </li>
            <li>
              For Luxury Bridal Collection items returned, $150 will be deducted
              for missing or damaged One and Only Signature Collection Reports.
            </li>
            <li>
              JEWLR reserves the right to deduct any fees we incur at the time
              of package receipt - including duties for incomplete paperwork.
            </li>
            <li>
              In cases where there is a coupon used to donate to a charity, the
              value of the coupon will be deducted from the refund.
            </li>
            <li>
              In cases where rewards points were used, the value of the rewards
              will be deducted from the refund, and
            </li>
            <li>
              In cases where you earned rewards points from your financial
              institution for any promotion where Jewlr was subsidizing the
              points, the dollar value of the subsidy will be deducted from the
              refund.
            </li>
          </SectionList>
          <Text subtitle>Reviews and Comments</Text>
          <Text>
            Anything that you submit or post to the Site, or to Customer
            Service, including but not limited to questions, comments,
            suggestions, ideas, plans, notes, photos, drawings, original or
            creative materials or other information and/or provide us, including
            without limitation, ideas, know-how, techniques, questions, reviews,
            comments, and suggestions (collectively, &quot;Submissions&quot;) is
            and will be treated as non-confidential and non-proprietary, and we
            shall have the royalty-free, worldwide, perpetual, irrevocable and
            transferable right to use, copy, distribute, display, publish,
            perform, sell, lease, transmit, adapt, create derivative works from
            such Submissions by any means and in any form, and to translate,
            modify, reverse-engineer, disassemble, or decompile such
            Submissions. In addition to the rights applicable to any Submission,
            when you post comments or reviews to the Site, you also grant us the
            right to use the name that you submit with any review, comment, or
            other Content, if any, in connection with such review, comment, or
            other content. You represent and warrant that you own or otherwise
            control all of the rights to the reviews, comments and other Content
            that you post on this Site and that use of your reviews, comments,
            or other Content by us will not infringe upon or violate the rights
            of any third party. You shall not use a false email address, pretend
            to be someone other than yourself or otherwise mislead us or third
            parties as to the origin of any Submissions or Content. We may, but
            shall not be obligated to, remove or edit any Submissions (including
            comments or reviews) for any reason.
          </Text>
        </Box>
      </Section>

      <Section hasBg>
        <Box contain>
          <SectionTitle>FREE WARRANTY WITH PURCHASE</SectionTitle>
          <Text subtitle>
            Free one-year warranty on all {jewlr_t("terms.jewelry")} purchases:
          </Text>
          <SectionList mb={4}>
            <li>
              The limited warranty covers against manufacturing defects and
              workmanship
            </li>
            <li>
              Coverage begins on your item’s shipment date for a term of 365
              days
            </li>
            <li>
              The warranty becomes void if the item has been subjected to misuse
              or has been altered by anyone other than an authorized Jewlr
              representative
            </li>
            <li>
              The warranty does not cover any {jewlr_t("terms.shipping")}{" "}
              charges related to a warranty repair
            </li>
            <li>
              The warranty does not cover lost or stolen items. Jewlr, Lee Fiori
              and their affiliates are not responsible for lost items.
            </li>
            <li>
              We reserve the right to void the warranty on any item that shows
              signs of modification, abuse, or damage beyond normal wear, as
              deemed by our {jewlr_t("terms.jewelry")} professionals
            </li>
          </SectionList>

          <Text subtitle>
            Free lifetime manufacturer’s warranty on all diamond engagement ring
            purchases from our Luxury Bridal Collection:
          </Text>
          <SectionList mb={4}>
            <li>
              The limited warranty covers against manufacturing defects and
              workmanship
            </li>
            <li>
              Coverage begins on your item’s shipment date for as long as you
              own the item
            </li>
            <li>
              The warranty becomes void if the item has been subjected to misuse
              or has been altered by anyone other than an authorized Jewlr
              representative
            </li>
            <li>
              The warranty does not cover any {jewlr_t("terms.shipping")}{" "}
              charges related to a warranty repair
            </li>
            <li>
              The warranty does not cover lost or stolen items. Jewlr, Lee Fiori
              and their affiliates are not responsible for lost or stolen items
            </li>
            <li>
              We reserve the right to void the warranty on any item that shows
              signs of modification, abuse, or damage beyond normal wear, as
              deemed by our {jewlr_t("terms.jewelry")} professionals
            </li>
          </SectionList>
          {sl.config.enable_watches && IS_NA() && (
            <>
              <Text subtitle>
                Free one-year warranty on all watch purchases:
              </Text>
              <SectionList>
                <li>
                  The limited warranty covers against manufacturing defects in
                  workmanship and materials, including movement mechanisms
                </li>
                <li>
                  If the movement is found defective, your watch will be
                  adjusted, repaired, or replaced with one of equal or greater
                  value, at our sole discretion
                </li>
                <li>
                  Coverage begins on your item’s shipment date for a term of 365
                  days
                </li>
                <li>
                  The warranty becomes void if the watch has been tampered with,
                  forced open, or repaired by anyone other than our watch repair
                  specialists, other than to replace a battery
                </li>
                <li>
                  The warranty does not cover straps, crystal/glass, batteries,
                  buttons, crowns, cases, or damage resulting from improper use,
                  accidents, or mishandling while changing the battery
                </li>
                <li>
                  The warranty does not include any shipping charges related to
                  a warranty repair
                </li>
                <li>
                  The warranty does not cover lost or stolen items. Jewlr, Lee
                  Fiori, and their affiliates are not responsible for lost items
                </li>
                <li>
                  We reserve the right to void this warranty if the damage is
                  due to negligence, as deemed by our watch professionals
                </li>
              </SectionList>
            </>
          )}
        </Box>
      </Section>
      {sl.config.enable_extend_warranty && (
        <Section>
          <Box contain>
            <SectionTitle>
              JEWLR + EXTEND: {jewlr_t("terms.jewelry").toUpperCase()}{" "}
              PROTECTION PLAN
            </SectionTitle>
            <Text subtitle>Coverage Type:</Text>
            <Text mb={0}>Accidental Damage from Handling (ADH)</Text>
            <Text mb={4}>Terms: 2yr, 3yr, 5yr</Text>

            <Text subtitle>Covered Products:</Text>
            <Text mb={0}>
              Bracelets, Earrings, Necklaces, Rings, Charms, and Pendants
            </Text>
            <Text mb={4}>
              Other: {jewlr_t("terms.Jewelry")} Sets, Body{" "}
              {jewlr_t("terms.Jewelry")}, Anklets, Brooches and Lapel Pins
            </Text>

            <Text subtitle>Types of Events:</Text>
            <Text mb={4}>
              Defects in manufacturer’s workmanship and/or materials, including
              normal wear and tear
            </Text>

            <Text subtitle>
              What’s Covered: Accidental Damage Repair & Service Coverage:
            </Text>
            <SectionList mb={4}>
              <li>Broken, bent, or worn prongs, clasps, and hinges</li>
              <li>Knotted or broken links in necklaces and bracelets</li>
              <li>Earring repair including broken or lost pins & posts</li>
              <li>Restringing of beads</li>
              <li>Re-shanking</li>
              <li>
                Ring sizing (excluding initial ring sizing at the time of
                purchase)
              </li>
              <li>Refinishing and polishing </li>
              <li>Rhodium plating white gold </li>
              <li> Chain soldering</li>
              <li>
                Resetting diamonds and gemstones and repair of chipped or
                cracked stones (including center stone){" "}
              </li>
              <li>
                Replacement of center stones and side/enhancement stones due to
                defect in the setting{" "}
              </li>
            </SectionList>
            <Text subtitle>What’s Not Covered:</Text>
            <Text>
              We will not replace continual damage, lost, or stolen{" "}
              {jewlr_t("terms.jewelry")}, unless otherwise noted under covered
              items.
            </Text>

            <Text subtitle>The Fine Print:</Text>
            <Text>
              Review the Extend Protection Plan - {jewlr_t("terms.Jewelry")}{" "}
              Care{" "}
              <Typography
                as="a"
                color="primary"
                href="https://customers.extend.com/warranty_terms/A0-AAJEW-5y"
                target="blank"
              >
                full terms and conditions
              </Typography>{" "}
              .
            </Text>
          </Box>
        </Section>
      )}
      {sl.config.enable_watches && sl.config.enable_extend_warranty && (
        <Section hasBg>
          <Box contain>
            <SectionTitle>JEWLR + EXTEND: WATCH PROTECTION PLAN</SectionTitle>
            <Text subtitle>Coverage Type:</Text>
            <Text mb={0}>Accidental Damage from Handling (ADH)</Text>
            <Text mb={0}>
              Service Type: Repair (replace under {to_currency(500)})
            </Text>
            <Text mb={4}>Terms: 1yr, 2yr, 3yr</Text>
            <Text subtitle>Covered Products:</Text>
            <Text mb={4}>Dress Watches, Quartz Watches</Text>

            <Text subtitle>Types of Events:</Text>
            <SectionList mb={4}>
              <li>
                Mechanical and/or electrical failures due to defects in
                materials or workmanship, or normal wear and tear
              </li>
              <li>Accidental Damage such as drops, scrapes, or spills</li>
            </SectionList>
            <Text subtitle>What’s Covered:</Text>
            <SectionList>
              <li>Mechanical Failure</li>
              <li>Battery Replacement</li>
              <li>Broken Stem</li>
              <li>Detached Crown</li>
            </SectionList>
            <Text subtitle>Repair Coverage:</Text>
            <SectionList>
              <li>Broken stem, band, case, or crystal</li>
              <li>
                Cracked / scratched crystal or anti-glare that prevents the
                customer from telling time
              </li>
              <li>Detached crown</li>
              <li>Battery replacement</li>
              <li>Debris visible on the dial</li>
              <li>Clasp security insufﬁcient</li>
              <li>Crown tube/threads stripped</li>
              <li>Loose pins in bracelet</li>
              <li>Movement stoppage and timing issues</li>
              <li>Torn or pinched gaskets from installation </li>
              <li>Straps/links installed incorrectly or reversed</li>
              <li>Hands alignment or locking up/not advancing</li>
              <li>Incorrect application of service adhesives</li>
            </SectionList>
            <Text subtitle>What’s Not Covered:</Text>
            <Text>
              Cosmetic damage such as dents, scratches or fraying of the band,
              fading of luminous, peeling of paint or bezel, modiﬁcations, and
              unauthorized repairs.
            </Text>
            <Text subtitle>The Fine Print:</Text>
            <Text>
              Review the Extend Protection Plan with Accident Coverage - Watch{" "}
              <Typography
                as="a"
                color="primary"
                href="https://customers.extend.com/warranty_terms/A0-AAJEW-5y"
                target="blank"
              >
                full terms and conditions
              </Typography>{" "}
              .
            </Text>
          </Box>
        </Section>
      )}
      <Section>
        <Box contain>
          <SectionTitle>INDEMNIFICATION</SectionTitle>
          <Text>
            You agree to indemnify and hold harmless JEWLR, its independent
            contractors, service providers and consultants, and their respective
            directors, employees and agents, from and against any claims,
            damages, costs, liabilities, and expenses arising out of or related
            to any Submissions you post, or submit, store or otherwise transmit
            on or through our Site or your use of or inability to use our Site,
            including without limitation any actual or threatened suit, demand
            or claim made against JEWLR and/or its independent contractors,
            service providers, employees, directors or consultants, arising out
            of or relating to the Submissions, your conduct, your violation of
            these Terms and Conditions or your violation of the rights of any
            third party.
          </Text>
        </Box>
      </Section>
      <Section hasBg>
        <Box contain>
          <SectionTitle>INTELLECTUAL PROPERTY</SectionTitle>
          <Text>
            The Site and all text, graphics, button icons, images, audio clips,
            the JEWLR logo, and software (collectively, &quot;Content&quot;),
            belongs exclusively to JEWLR, or its affiliates. The collection,
            arrangement, ‘look and feel’ and assembly of all Content on this
            Site (the Arrangement) belongs exclusively to JEWLR or its
            affiliates. All software, data and information used on this Site
            (the &quot;Software&quot;) is the property of JEWLR, its affiliates
            or its Software suppliers. The Content, the Arrangement and the
            Software are all protected by U.S. and international copyright laws.
            JEWLR.COM, logos, slogans, trade names or words are registered
            trademarks, trademarks or service marks of JEWLR, its affiliates,
            suppliers, or third parties. The use of any of our trademarks or
            service marks without our express written consent is strictly
            prohibited. You may not use our trademarks or service marks in
            connection with any product or service in any way that is likely to
            cause confusion. You may not use our trademarks or service marks in
            any manner that disparages or discredits us. You may not use any of
            our trademarks or service marks in meta tags without prior explicit
            consent.
          </Text>
        </Box>
      </Section>
      <Section>
        <Box contain>
          <SectionTitle>LINKS – THIRD PARTY CONTENT</SectionTitle>
          <Text>
            This site may contain links to other sites on the Internet that are
            owned and operated by third parties. You acknowledge that we are not
            responsible for the operation of or content located on or through
            any such site.
          </Text>
        </Box>
      </Section>
      <Section hasBg>
        <Box contain>
          <SectionTitle>PRIVACY POLICY</SectionTitle>
          <Text>
            Please review our{" "}
            <Link data-lc="terms-conditions" to="/info/privacy-policy">
              Privacy Policy
            </Link>
            , which also governs your visit to this Site, to understand our
            practices.
          </Text>
        </Box>
      </Section>
      <Section>
        <Box contain>
          <SectionTitle>RISK OF LOSS</SectionTitle>
          <Text>
            The risk of loss and title for items purchased by you pass to you
            upon our delivery of the item to the carrier. JEWLR will not be
            responsible for lost or stolen items.
          </Text>
        </Box>
      </Section>
      <Section hasBg>
        <Box contain>
          <SectionTitle>INSURANCE</SectionTitle>
          <Text>
            JEWLR recommends obtaining 3rd party insurance against lost or theft
            for any item received.
          </Text>
        </Box>
      </Section>
      <Section>
        <Box contain>
          <SectionTitle>TERMINATION AND EFFECT OF TERMINATION</SectionTitle>
          <Text>
            Notwithstanding any of these Terms and Conditions, JEWLR reserves
            the right, without notice and in its sole discretion, to terminate
            this Agreement and your license to use this site, and to block or
            prevent future your access to and use of the Site. JEWLR may,
            without prior notice to you, immediately terminate the Agreement or
            revoke any or all of your rights granted under this Agreement. Upon
            any termination of this Agreement, you shall immediately cease all
            access to and use of the Site and we shall, in addition to any other
            legal or equitable remedies, immediately revoke all password(s) and
            account identification issued to you and deny your access to and use
            of this Site in whole or in part. Any termination of this Agreement
            shall not affect the respective rights and obligations of the
            parties arising before the date of termination.
          </Text>
        </Box>
      </Section>
      <Section hasBg>
        <Box contain>
          <SectionTitle>APPLICABLE LAW</SectionTitle>
          <Text>
            This site is created and controlled by Jewlr and 6888887 Canada Inc.
            As such, the laws of the Province of Ontario will govern these
            disclaimers, terms, and conditions, without giving effect to any
            principles of conflicts of laws. You agree that any action at law or
            in equity arising out of or relating to these Terms and Conditions
            shall be filed only in the Province of Ontario and you hereby
            irrevocably and unconditionally consent and submit to the exclusive
            jurisdiction of such courts over any suit, action or proceeding
            arising out of your use of this site, any purchase from this site,
            or these Terms and Conditions.
          </Text>
        </Box>
      </Section>
      <Section>
        <Box contain>
          <SectionTitle>DISPUTES</SectionTitle>
          <Text>
            Any dispute relating in any way to your visit to the Site or to the
            products you purchase through the Site shall be submitted to
            confidential arbitration in the Province of Ontario.You agree that
            regardless of any statute or law to the contrary, any claim or cause
            of action arising out of, related to or connected with the use of
            the Site or this Agreement must be filed within one (1) year after
            such claim or cause of action arose or be forever banned.
          </Text>
        </Box>
      </Section>
      <Section hasBg>
        <Box contain>
          <SectionTitle>LIMITATION OF LIABILITY</SectionTitle>
          <Text>
            Except as expressly provided to the contrary in writing by JEWLR,
            this site, the products offered for sale on it and the transactions
            conducted through it are provided by us on an &quot;as is&quot;
            basis. We make no representations or warranties of any kind, express
            or implied, as to the operation of the site or the information,
            content, materials, or products included on this site except as
            provided here and on the webpages to which that webpage links. To
            the full extent permissible by applicable law, we disclaim all
            warranties, express or implied, including, but not limited to,
            implied warranties of merchantability and fitness for a particular
            purpose, noninfringement, title, quiet enjoyment, data accuracy and
            system integration. This site may include inaccuracies, mistakes or
            typographical errors. We do not warrant that the content will be
            uninterrupted or error free. To the maximum extent permitted by law,
            we will not be liable for any damages of any kind arising from the
            use of this site, including, but not limited to indirect,
            incidental, punitive, exemplary, special or consequential damages.
            To the maximum extent permitted by applicable law, our total
            liability to you for any damages (regardless of the foundation for
            the action) shall not exceed in the aggregate the amount of fees
            actually paid by you to us during the month immediately preceding
            the act allegedly giving rise to our liability.
          </Text>
        </Box>
      </Section>
      <Section>
        <Box contain>
          <SectionTitle>INTERNATIONAL ACCESS</SectionTitle>
          <Text>
            This Site may be accessed from countries outside of North America,
            Australia and the EU. This Site may contain products or services
            that are not available worldwide. Any such references do not imply
            that such products will be made available worldwide. If you access
            and use this Site you are responsible for complying with your local
            laws and regulations.
          </Text>
        </Box>
      </Section>
      <Section hasBg>
        <Box contain>
          <Box
            display="block"
            id="gift_card"
            position="relative"
            top="-150px"
            visibility="hidden"
          />
          <SectionTitle>GIFT CARD TERMS & CONDITIONS</SectionTitle>
          <SectionList mb={4}>
            <li>
              The Jewlr Gift Card can only be used online at one of Jewlr&apos;s
              or Lee Fiori’s online stores: jewlr.com, jewlr.ca, jewlr.co.uk,
              jewlr.com.au, leefiori.ca, or leefiori.com.
            </li>
            <li>
              Gift Cards will not be replaced or refunded if lost or stolen.
              Jewlr, Lee Fiori and their affiliates are not responsible for lost
              Gift Cards.
            </li>
            <li>
              Gift Cards will not be returnable or exchangeable for cash, except
              in states where required by law.
            </li>
            <li>A Gift Card cannot be used to purchase Gift Cards.</li>
            <li>
              Purchase amounts that exceed the value of the tendered Gift Card
              will require a credit card or PayPal payment for the balance due.
            </li>
            <li>
              Your Gift Card will be emailed to the recipient after the order
              has been processed and payment taken.
            </li>
            <li>
              Your Gift Card will be emailed to the recipient email address you
              enter. Ensure the recipient email address is correct when you
              place your order. Jewlr is not liable for delivery of a Gift Card
              to an incorrect or non-existent email address. The correct email
              address to where the Gift Card will be sent is the sole
              responsibility of the purchaser.
            </li>
            <li>
              All returned items that were purchased with a Gift Card will be
              refunded as a credit to the Jewlr Gift Card for you to use again
              in the future on either of Jewlr’s or Lee Fiori’s online stores.
            </li>
            <li>
              For item(s) purchased with both a Gift Card and credit card or
              paypal account, you will be refunded on the credit card or paypal
              account up to the amount of your initial payment and the remaining
              amount will be refunded as a credit to the Jewlr Gift Card for you
              to use again in the future.
            </li>
            <li>
              Your Jewlr Gift Card must be used on the site in the currency in
              which it was purchased.
            </li>
          </SectionList>
          <Text subtitle>How to Obtain Your Balance</Text>
          <Text mb={4}>
            To obtain your balance on a Jewlr Gift Card, please call Jewlr
            customer service at 1-866-610-8482 or Lee Fiori customer service at
            1-833-533-3467. Please note that in most cases, the balance is
            adjusted immediately when you make a purchase, but there may be
            occasions when the updated balance is delayed for a period of time.
          </Text>
          <Text subtitle>Expiration / Service Fees</Text>
          <Text mb={4}>
            Jewlr Gift Cards do not expire and we do not assess any service fees
            for non-use.
          </Text>
          <Text subtitle>Compliance With Law</Text>
          <Text mb={4}>
            By purchasing Jewlr Gift Cards, you are certifying and representing
            to Jewlr, Lee Fiori and its affiliates that the activities in
            connection with which the Jewlr Gift Cards will be used, comply with
            these Terms and Conditions and all applicable laws, rules and
            regulations, including the Terms and Conditions that govern the
            Jewlr web site and the Lee Fiori web site. In addition, you agree to
            defend and indemnify Jewlr and Lee Fiori and their affiliates from
            and against any claims, expenses or liabilities made against or
            incurred by any of them in connection with your use of the Jewlr
            Gift Card(s) or violation of any of these Terms and Conditions.
          </Text>
          <Text subtitle>Acceptance Of These Terms And Conditions</Text>
          <Text>
            Your purchase or use of a Jewlr Gift Card constitutes acceptance of
            these Terms and Conditions. These Terms and Conditions are subject
            to change without notice.
          </Text>
          {IS_UK() && (
            <Text mt={5}>Jewlr UK Limited. Business Number 10010600</Text>
          )}
        </Box>
      </Section>
      <Section>
        <Box contain>
          <SectionTitle>GIVEAWAY RULES & REGULATIONS</SectionTitle>
          <SectionList mb={4}>
            <li>Monthly Giveaways begin on the first of each month.</li>
            <li>
              One winner will be chosen by random draw on the last day of the
              month.
            </li>
            <li>Winner will be contacted via email.</li>
            <li>Prize must be accepted as awarded.</li>
            <li>
              Open to US, CA, UK and AU residents 18+ (excl. Quebec and Northern
              Ireland).
            </li>
            <li>Odds of winning depend on the number of entries received.</li>
            <li>Void where prohibited by law.</li>
            <li>No purchase necessary.</li>
          </SectionList>
        </Box>
      </Section>
    </Box>
  )
}

export default TermsConditions
